/*
    THIS FILE WAS DEVELOPED BY MEHMET GUDUK
    © 2022 COPYRIGHT, LICENSED WITH GPL-3.0 LICENSE, AUTHOR IS MEHMET GUDUK
    https://github.com/mehmetguduk
*/

import React from 'react';

export default function Socials() {
    return (
        <div className='socials'>
            <div className='socials-container'>
                <a className="social" href="https://www.linkedin.com/in/mehmetguduk/" target="_blank" rel="noreferrer">
                    <i class="social-logo fa fa-linkedin-square" aria-hidden="true"></i>
                </a>
                <a className='social' href="https://github.com/mehmetguduk" target="_blank" rel="noreferrer">
                    <i class="social-logo fa fa-github-square" aria-hidden="true"></i>
                </a>
            </div>
        </div>
    )
}